import { UserDataType } from "../Data/UserData";
import { StationProps, LineProps } from "../Data/UserData";
import { t } from "i18next";

const stationsData: StationProps[] = require('../Data/stations.json');
const linesData: LineProps[] = require('../Data/lines.json');

export const teyvat: UserDataType = {
  stations: stationsData.reduce((map, cur) => {
    map.set(cur.stationId, cur);
    return map;
  }, new Map()),
  lines: linesData.reduce((map, cur) => {
    map.set(cur.lineId, cur);
    return map;
  }, new Map()),
  title: t("Metro"),
  backgroundColor: "#fff",
};
